import React from 'react';

import { Caption, Heading } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';

import styles from './styles.module.css';

type Props = {
  title: string;
  text: string;
  cta?: React.ReactNode;
  className?: string;
};

export function EmptyMessage({ title, text, cta, className }: Props) {
  return (
    <div className={clsx(styles.wrapper, className)}>
      <Heading variant="sm" className={styles.title}>
        {title}
      </Heading>
      <Caption variant="lg-regular">{text}</Caption>
      {cta && <div className={styles.cta}>{cta}</div>}
    </div>
  );
}
